var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawPicProfileRe7G2A({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_5506)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_278_5506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0281 22.9152C24.9953 22.9152 26.59 21.3205 26.59 19.3533C26.59 17.3862 24.9953 15.7915 23.0281 15.7915C21.061 15.7915 19.4663 17.3862 19.4663 19.3533C19.4663 21.3205 21.061 22.9152 23.0281 22.9152Z",
    stroke: "#2732D4",
    strokeWidth: 2.8428,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3038 30.9999V25.2332H24.9504L23.0282 26.9293L21.1059 25.2332H16.7526V30.9999",
    stroke: "#2732D4",
    strokeWidth: 2.8428,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0282 23.7067C20.6536 23.7067 18.6748 21.7279 18.6748 19.3534C18.6748 16.9788 20.5971 15 23.0282 15C25.4593 15 27.3815 16.9788 27.3815 19.3534C27.3815 21.7279 25.4027 23.7067 23.0282 23.7067ZM23.0282 16.6396C21.5017 16.6396 20.3144 17.8834 20.3144 19.3534C20.3144 20.8233 21.5582 22.0671 23.0282 22.0671C24.5547 22.0671 25.7419 20.8233 25.7419 19.3534C25.7419 17.8834 24.4981 16.6396 23.0282 16.6396Z",
    fill: "#2732D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0954 31H28.5123V26.0247H25.2332L23.5371 27.4947H22.4628L20.7667 26.0247H17.5441V31H15.9045V25.2332L16.7526 24.4417H21.106L21.6148 24.6113L23.0282 25.8551L24.4416 24.6113L24.9505 24.4417H29.3038L30.0954 25.2332V31Z",
    fill: "#2732D4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_5506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_278_5506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPicProfileRe7G2A);
export default __webpack_public_path__ + "static/media/undraw_pic_profile_re_7g2a.a049ca2937a4f2f498049989c1011e19.svg";
export { ForwardRef as ReactComponent };